goog.provide('el8.appchart.dialog.tesst');

goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.appservice.notifier');


el8.appchart.dialog.tesst = (function() {

    var _Options;

    if (el8Globals.APP === 'chart') {
        var _Options = [
            {
                url: el8Globals.PATIENT_PATH + 'syndromic_data/registration/export',
                name: 'Export Registration Syndromic Surveillance Registration'
            },
            {
                url: el8Globals.PATIENT_PATH + 'syndromic_data/discharge/export',
                name: 'Export Syndromic Surveillance Discharge'
            },
            {
                url: el8Globals.PATIENT_PATH + 'syndromic_data/update/export',
                name: 'Export Syndromic Surveillance Update'
            },
            {
                url: el8Globals.PATIENT_PATH + 'syndromic_data/admission/export',
                name: 'Export Syndromic Surveillance Admission'
            }
        ];
    }

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Data Exchange Functions',
        list: _Options,
        callbackFn: function(index) {
            if (_Options[index]['url']) {
                var url = _Options[index]['url'];
                window.open(url);
            } else if (_Options[index]['callbackFn']) {
                _Options[index]['callbackFn']();
            }
            that.hide();

        },
        getTextFn: function(obj) {
            return obj['name'];
        }
    });

    return that;

})();

